export default "__VITE_ASSET__NytnUBPZ__"